"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snakeToCamelCase = void 0;
var _lodash = require("lodash");
const snakeToCamelCase = obj => {
  if (Array.isArray(obj)) {
    return obj.map(item => snakeToCamelCase(item));
  }
  if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const camelCaseKey = (0, _lodash.camelCase)(key);
      acc[camelCaseKey] = snakeToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};
exports.snakeToCamelCase = snakeToCamelCase;